import { config } from '@/config';
import { tokenStore } from './api/baseAPI';

export interface WSOptions {
  onMessage: (data: unknown) => void;
  onOpen?: () => void;
  onClose?: (e: CloseEvent) => void;
  onError?: (e: Event) => void;
}

export const connectAlertsWS = (opts: WSOptions): WebSocket => {
  const token = tokenStore.getAccess();
  const url = token ? `${config.ws.alerts}?token=${encodeURIComponent(token)}` : config.ws.alerts;

  const ws = new WebSocket(url);

  ws.onopen = () => opts.onOpen?.();
  ws.onmessage = (e) => {
    try {
      opts.onMessage(JSON.parse(e.data));
    } catch {
      opts.onMessage(e.data);
    }
  };
  ws.onclose = (e) => opts.onClose?.(e);
  ws.onerror = (e) => opts.onError?.(e);

  return ws;
};
